import React from 'react'
import {Redirect, Route} from 'react-router-dom';
import {useAuth} from '../../contexts/AuthContext';

export default function AdminRoute({ component: Component, ...rest}) {
  const { currentUser } = useAuth();

  return (
    <>
    {currentUser  && (
      <Route {...rest}
      render={props =>{
        return currentUser.role === 'admin' ? <Component {...props}/> : <Redirect to="/login"/>
      }}
    ></Route>
    )}
    {!currentUser  && (
      <Route {...rest}
      render={() =>{
        return <Redirect to="/login"/>
      }}
    ></Route>
    )}
  </>
  )
}
